import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AppointmentRow from './AppointmentRow'
import { renderAlert } from '../../../services/render-alert'
import {
  getPatientAppointments,
  requestReview,
} from '../../../state/actions/selected-patient'
import css from './appointments.css'

class Appointments extends Component {
  static propTypes = {
    appointments: PropTypes.arrayOf(PropTypes.object).isRequired,
    patientId: PropTypes.string.isRequired,
    getPatientAppointments: PropTypes.func.isRequired,
  }

  state = {
    isFetching: false,
  }

  componentDidMount() {
    const {
      appointments,
      patientId,
      getPatientAppointments,
      activeLocation,
    } = this.props
    if (!this.state.isFetching && appointments.length === 0) {
      this.setState({ isFetching: true })
      const locationId = activeLocation && activeLocation.id
      getPatientAppointments(patientId, locationId).then(() =>
        this.setState({ isFetching: false }),
      )
    }
  }

  componentDidUpdate(prevProps) {
    const { activeLocation: prevLocation } = prevProps
    const { activeLocation, patientId, getPatientAppointments } = this.props
    if (
      activeLocation &&
      prevLocation &&
      activeLocation.id !== prevLocation.id
    ) {
      getPatientAppointments(patientId, activeLocation.id)
    }
  }

  handleRequestReview = async (patientId, appointmentId, type) => {
    const { requestReview } = this.props
    try {
      const { body } = await requestReview(patientId, appointmentId, type)
      if (body && body.opted_out) {
        renderAlert(`Patient is opted out of messages via ${type}.`, 'error')
        return true
      } else if (body && body.message_create_failure) {
        renderAlert(
          `Unable to create review message via ${type}. Please check that patient's ${type} information is valid.`,
          'error',
        )
        return true
      }
      renderAlert(`Review successfully requested via ${type}.`, 'success')
      return true
    } catch (err) {
      console.error(err)
      return false
    }
  }

  render() {
    const { appointments, hasReviews } = this.props
    switch (true) {
      case this.state.isFetching:
        return <h2>Loading Appointments...</h2>
      case !appointments.length:
        return <h2>No Appointments found</h2>
      default:
        return (
          <ul className={css.container}>
            {appointments.map(appointment => (
              <AppointmentRow
                key={appointment.id}
                appointment={appointment}
                hasReviews={hasReviews}
                requestReview={this.handleRequestReview}
              />
            ))}
          </ul>
        )
    }
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasReviews },
  },
  selectedPatient,
}) => ({
  appointments: selectedPatient.appointments,
  hasReviews,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPatientAppointments, requestReview }, dispatch)

Appointments.propTypes = {
  hasReviews: PropTypes.bool.isRequired,
  requestReview: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(Appointments)



// WEBPACK FOOTER //
// ./src/components/PatientPage/Appointments/index.js